import { Car, formDataInitial, FormDataModel } from "helpers/global-types";
import { Cart } from "store/types";

const mapVehicle = (
  vehicle: NonNullable<Cart["vehicle"]>,
  roundtrip?: number
): Car => {
  const hasSeparatePrices =
    typeof vehicle.oneway_price !== "undefined" &&
    typeof vehicle.roundtrip_price !== "undefined";
  const price = hasSeparatePrices
    ? roundtrip
      ? parseFloat(vehicle.roundtrip_price)
      : parseFloat(vehicle.oneway_price)
    : vehicle.price
      ? parseFloat(vehicle.price)
      : 0;

  return {
    carName: vehicle.name,
    price: price,
    vehicleId: vehicle.vehicle_id,
    numberOfSeats: parseFloat(vehicle.passenger_limit),
    picturePath: vehicle.image,
    oneSeatAllowed: false,
    noMoreThenAmountOfPeople:
      vehicle.type === "shuttle" ? Number(vehicle.passenger_limit) : Infinity,
    isShuttle: vehicle.type === "shuttle",
    description: vehicle.description,
    tripType: roundtrip ? "Round trip" : "One way",
  };
};

export const mapCartToForm = (cart: Cart): FormDataModel => {
  const formData: FormDataModel = { ...formDataInitial };

  if (cart.location) formData.pickupLocation = cart.location;
  if (cart.destination) formData.destinationLocation = cart.destination;
  if (cart.passengers !== undefined)
    formData.numberOfPassengers = Number(cart.passengers);
  if (cart.roundtrip !== undefined)
    formData.roundTripReservation = Boolean(cart.roundtrip);
  if (cart.vehicle)
    formData.selectedCar = mapVehicle(cart.vehicle, cart.roundtrip);

  if (cart.booking_date) formData.bookingDate = cart.booking_date;
  if (cart.booking_time) formData.bookingTime = cart.booking_time;
  if (cart.departure_date) formData.departureDate = cart.departure_date;
  if (cart.departure_time) formData.departureTime = cart.departure_time;
  if (cart.notes) formData.bookingDetailsNotes = cart.notes;
  if (cart.sign_name) formData.signName = cart.sign_name;
  if (cart.arrival_flight_number)
    formData.arrivalFlightNumber = cart.arrival_flight_number;
  if (cart.arrival_flight_airline)
    formData.arrivalAirline = cart.arrival_flight_airline;
  if (cart.departure_flight_number)
    formData.departureFlightNumber = cart.departure_flight_number;
  if (cart.departure_flight_airline)
    formData.departureAirline = cart.departure_flight_airline;

  if (cart?.firstname) formData.firstName = cart?.firstname;
  if (cart?.lastname) formData.lastName = cart?.lastname;
  if (cart?.email) {
    formData.emailAddress = cart?.email;
    formData.confirmEmailAddress = cart?.email;
  }
  if (cart?.phone) formData.mobilePhone = cart?.phone;
  if (cart?.phone2) formData.additionalPhone = cart?.phone2;
  if (cart?.country_id)
    formData.country = {
      name: "",
      country_id: String(cart?.country_id),
    };
  if (cart?.state_id)
    formData.state = {
      name: "",
      state_id: String(cart?.state_id),
      type: "",
    };
  if (cart?.address) formData.address = cart?.address;
  if (cart?.address2) formData.address2 = cart?.address2;
  if (cart?.city) formData.city = cart?.city;
  if (cart?.zip) formData.postalCode = cart?.zip;

  return formData;
};
